export const onEscape = (condition: () => boolean, callback: () => void) => {
    const handler = (event: KeyboardEvent) => {
        if (event.key === "Escape" && condition()) {
            callback();
        }
    };
    document.addEventListener("keydown", handler);

    return () => {
        document.removeEventListener("keydown", handler);
    };
};
